<template>

  <ui-card name="overview.geography_overview" :is-loading="isLoading" :error="error" padded>
    <geo-map :data="data" />

    <div class="columns" v-if="data && data.length > 0">
      <div class="column">
        <div class="country" v-for="(item, index) in data.slice(0, 3)" :key="index" :class="{ 'is-first': index === 0 }">
          <div class="country-name">{{ data.indexOf(item) + 1 }}. {{ item[1] }}</div>
          <div class="country-percentage">{{ item[3] }}%</div>
        </div>
      </div>
      <div class="column">
        <div class="country" v-for="(item, index) in data.slice(3, 6)" :key="index">
          <div class="country-name">{{ data.indexOf(item) + 1 }}. {{ item[1] }}</div>
          <div class="country-percentage">{{ item[3] }}%</div>
        </div>
      </div>
      <div class="column">
        <div class="country" v-for="(item, index) in data.slice(6, 9)" :key="index">
          <div class="country-name">{{ data.indexOf(item) + 1 }}. {{ item[1] }}</div>
          <div class="country-percentage">{{ item[3] }}%</div>
        </div>
      </div>
    </div>

    <div class="columns" v-else-if="isLoading">
      <div class="column" v-for="(item, index) in new Array(3)" :key="index">
        <div class="blokk shimmer blokk-country is-small">
          <div>-&#x20;---</div>
          <div>---</div>
        </div>
        <div class="blokk shimmer blokk-country is-small">
          <div>-&#x20;-----</div>
          <div>---</div>
        </div>
        <div class="blokk shimmer blokk-country is-small">
          <div>-&#x20;--</div>
          <div>--</div>
        </div>
      </div>
    </div>

  </ui-card>

</template>

<script>
import { has, map, reduce, sortBy, reverse, keyBy, round } from 'lodash';
import GeoMap from 'views/charts/GeoMap';
import countries from 'config/countries.json';
import { card } from 'views/mixins';

const names = {
  byCountryCode: keyBy(countries, 'country-code'),
  byAlpha3: keyBy(countries, 'alpha-3'),
};

export default {
  extends: card('filter-dates'),

  components: {
    GeoMap,
  },

  methods: {
    makeQuery(params) {
      return `
        {
          "app_id": "${params.appId}",
          "transformations": [],
          "sets": [
            {
              "store": "geo_stationaries",
              "measures": [
                {
                  "measure": "nr_users",
                  "agg": "sum"
                }
              ],
              "dimensions": [
                {
                  "dim": "geo_adm0_a3"
                },
                {
                  "dim": "geo_iso_n3"
                }
              ],
              "filters": [
                {
                  "scope": "req",
                  "type": "range",
                  "dim": "isotime",
                  "begin": "${params.from}",
                  "end": "${params.to}"
                }
              ]
            }
          ]
        }
      `;
    },

    parseData(set) {
      let rows = set.rows;

      rows = sortBy(rows, o => o[2]);
      rows = reverse(rows);

      const total = reduce(rows, (sum, row) => sum + row[2], 0);
      const values = map(rows, row => {
        const percentage = round((row[2] / total) * 100, 2);
        const country = names.byAlpha3[row[0]] || names.byCountryCode[row[1]];

        return [country['country-code'], country['name'], row[2], percentage];
      });

      return values;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.content {
  &:not(.content-none-state) {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
  }
}

.geo-map {
  width: 100%;
  height: 11rem;
}

.country {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: $size-small;
  color: $grey-darker;

  &.is-first {
    font-weight: 500;
  }
}

.country-name {
  max-width: 6.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.country-percentage {
  opacity: 0.5;
}

.blokk-country {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>